<template>
    <ckeditor v-model="editorData" :config="editorConfig"></ckeditor>
</template>

<script>
export default {
    name: 'app',

    props: {
        textIn: '',
    },

    data() {
        return {
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {},
        };
    },

    created() {
        this.editorData = this.textIn;
    },

    watch: {
        ['editorData'](val) {
            this.$emit('input', val);
        },
    },
};
</script>
